/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heading_Contact_Fiverr_PrefixInputs */

const en_heading_contact_fiverr_prefix = /** @type {(inputs: Heading_Contact_Fiverr_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available`)
};

const ar_heading_contact_fiverr_prefix = /** @type {(inputs: Heading_Contact_Fiverr_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متاح`)
};

const bn_heading_contact_fiverr_prefix = /** @type {(inputs: Heading_Contact_Fiverr_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অ্যাভেইলেবল`)
};

const de_heading_contact_fiverr_prefix = /** @type {(inputs: Heading_Contact_Fiverr_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbar`)
};

const es_heading_contact_fiverr_prefix = /** @type {(inputs: Heading_Contact_Fiverr_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponible`)
};

const fr_heading_contact_fiverr_prefix = /** @type {(inputs: Heading_Contact_Fiverr_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponible`)
};

const pt_heading_contact_fiverr_prefix = /** @type {(inputs: Heading_Contact_Fiverr_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponível`)
};

const zh_heading_contact_fiverr_prefix = /** @type {(inputs: Heading_Contact_Fiverr_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可用`)
};

const tr_heading_contact_fiverr_prefix = /** @type {(inputs: Heading_Contact_Fiverr_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mevcut`)
};

const ru_heading_contact_fiverr_prefix = /** @type {(inputs: Heading_Contact_Fiverr_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступен`)
};

const pl_heading_contact_fiverr_prefix = /** @type {(inputs: Heading_Contact_Fiverr_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostępne`)
};

/**
* | output |
* | --- |
* | "Available" |
*
* @param {Heading_Contact_Fiverr_PrefixInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const heading_contact_fiverr_prefix = /** @type {((inputs?: Heading_Contact_Fiverr_PrefixInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heading_Contact_Fiverr_PrefixInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_heading_contact_fiverr_prefix(inputs)
	if (locale === "bn") return bn_heading_contact_fiverr_prefix(inputs)
	if (locale === "de") return de_heading_contact_fiverr_prefix(inputs)
	if (locale === "es") return es_heading_contact_fiverr_prefix(inputs)
	if (locale === "fr") return fr_heading_contact_fiverr_prefix(inputs)
	if (locale === "pt") return pt_heading_contact_fiverr_prefix(inputs)
	if (locale === "zh") return zh_heading_contact_fiverr_prefix(inputs)
	if (locale === "tr") return tr_heading_contact_fiverr_prefix(inputs)
	if (locale === "ru") return ru_heading_contact_fiverr_prefix(inputs)
	if (locale === "pl") return pl_heading_contact_fiverr_prefix(inputs)
	return en_heading_contact_fiverr_prefix(inputs)
});